'use client';

import type { ReactNode } from 'react';
import { z } from 'zod';
import { CoderRenderer } from '../../ToolCallsRenderers/renderers/CoderRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

const CoderResultSchema = z
  .looseObject({
    script: z.string().optional(),
    code: z.string().optional(),
  })
  .transform(({ script, code, ...rest }) => ({
    ...rest,
    script: script ?? code,
  }));

export const renderCoderResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight } = ctx;

  const result = CoderResultSchema.safeParse(content);
  if (result.success) {
    return <CoderRenderer data={result.data} maxHeight={maxHeight} />;
  }

  return <CoderRenderer data={content} maxHeight={maxHeight} />;
};
